/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/video/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'video/desktop.app', exports: {} };
const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import jwplayer from '@take-2/fd-modules/video/jwplayer';



import freewheel from '@take-2/fd-modules/video/jwplayer/freewheel';

function run() {
    checkDependencies(module.name, debugLog);
    freewheel.init(jwplayer.init);
}
document.addEventListener('DOMContentLoaded', run);
export default {  };